import _get from 'lodash/get'
import React, { useState, useEffect } from 'react'

import loSto from '../../config/loSto'
import {
  Container,
  Content,
  Button,
  ButtonContent
} from './emrConnectionToolBar.styled.js'
import pubSub from '../../lib/util/pubSub'
import { LO_STO } from '../../lib/constants'
import EMRSignInModal from './components/emrSignInModal'
import { handleEmrRedirection } from './helpers/emrRedirect'
import { isEmrIntegrationToolBarVisible } from '../../helpers/emrIntegration'
import { EMR_INTEGRATION_DETAILS_UPDATE } from '../../constants/pubSub.events.js'

const EMRConnectionToolBar = () => {
  const [isVisible, setVisibility] = useState(isEmrIntegrationToolBarVisible())
  const [isPopupVisible, setPopupVisibility] = useState(false)

  const handleClosePopup = () => {
    setPopupVisibility(false)
    const emrIntegrationDetails =
      loSto.get(LO_STO.EMR_INTEGRATION_DETAILS) || {}
    loSto.set(LO_STO.EMR_INTEGRATION_DETAILS, {
      ...emrIntegrationDetails,
      additional: {
        displayEmrIntegrationAlert: false
      }
    })
  }

  const handleRedirectToEmr = () => {
    setPopupVisibility(false)
    handleEmrRedirection()
  }

  const handleOpenPopup = () => {
    setPopupVisibility(true)
  }

  const handleEmrIntegrationDetailsUpdate = () => {
    setVisibility(isEmrIntegrationToolBarVisible())
    const emrIntegrationDetails =
      loSto.get(LO_STO.EMR_INTEGRATION_DETAILS) || {}
    const shouldDisplayEmrIntegrationAlert = _get(
      emrIntegrationDetails,
      'additional.displayEmrIntegrationAlert',
      false
    )
    setPopupVisibility(shouldDisplayEmrIntegrationAlert)
  }

  useEffect(() => {
    const subscription = pubSub.subscribe(
      EMR_INTEGRATION_DETAILS_UPDATE,
      handleEmrIntegrationDetailsUpdate
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  if (!isVisible) {
    return null
  }

  return (
    <>
      <Container>
        <Content>Not connected to your EMR.</Content>
        <Button onClick={handleOpenPopup}>
          <ButtonContent>Try connecting</ButtonContent>
        </Button>
      </Container>
      <EMRSignInModal
        isVisible={isPopupVisible}
        closePopup={handleClosePopup}
        redirectToEmr={handleRedirectToEmr}
      />
    </>
  )
}

export default EMRConnectionToolBar
